.section {
  padding-top: calc(88px * 0.7);
}

.section :global(.subtitle) {
  max-width: 720px;
  margin-bottom: 36px;
}

.frame {
  position: relative;
  width: 100%;
}

.glow {
  position: absolute;
  inset: 8% 4%;
  background: radial-gradient(
    ellipse at 50% 50%,
    rgba(124, 58, 237, 0.35),
    transparent 70%
  );
  filter: blur(36px);
  pointer-events: none;
}

.player {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-lg);
  background: #050408;
  box-shadow:
    var(--shadow-glow),
    0 24px 56px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.caption {
  margin: 16px 0 0;
  font-size: 13px;
  text-align: center;
  color: var(--color-text-dim);
}

.link {
  color: var(--color-gold);
  text-decoration: underline;
  text-decoration-color: var(--color-gold-dim);
  text-underline-offset: 3px;
  transition: color 0.15s ease;
}

.link:hover {
  color: var(--color-gold-bright);
}

@media (max-width: 640px) {
  .section {
    padding-top: calc(64px * 0.7);
  }

  .section :global(.subtitle) {
    margin-bottom: 28px;
  }

  .player {
    border-radius: var(--radius-md);
  }
}
